import Topic from '../../../api/Topic';
import * as types from './mutation-types';

export const store = async ({commit}, {params}) => {
    const json = await new Topic().store(params);

    commit(types.TOPIC, json[0]);
};

export const show = async ({commit}, {id}) => {
    const json = await new Topic().show(id);

    commit(types.TOPIC, json);
};

export const update = async (context, {id, params}) => {
    await new Topic().update(id, params);
};

export const updateTopicStatus = async (context, {id, params}) => {
    await new Topic().updateTopicStatus(id, params)
};

export const destroy = async (context, {id}) => {
    await new Topic().destroy(id)
};

export const getAll = async ({commit}) => {
    const json = await new Topic().getAll();

    commit(types.TOPICS, json);
};

export default {
    store,
    show,
    update,
    updateTopicStatus,
    destroy,
    getAll,
};



// WEBPACK FOOTER //
// ./src/store/modules/topic/actions.js